import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import nlTranslation from './locales/nl/translation.json';

// Initialize i18next
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'nl',
    debug: process.env.NODE_ENV === 'development',

    // Configure language detection - prioritize Dutch for Netherlands users
    detection: {
      // Order of language detection methods - localStorage first, then default to Dutch
      order: ['localStorage'],

      // Only look for supported languages
      checkWhitelist: true,

      // Cache language in localStorage
      caches: ['localStorage'],

      // Map browser languages to supported languages
      lookupLocalStorage: 'i18nextLng',

      // Convert unsupported languages to supported ones
      convertDetectedLanguage: lng => {
        // For Netherlands-focused app, be more aggressive about defaulting to Dutch
        const dutchVariants = ['nl', 'nl-NL', 'nl-BE'];
        const englishVariants = ['en', 'en-US', 'en-GB'];

        // Only allow English if explicitly set in localStorage
        if (englishVariants.includes(lng)) {
          const stored = localStorage.getItem('i18nextLng');
          if (stored === 'en') {
            return 'en';
          }
          // Otherwise default to Dutch
          return 'nl';
        }

        // Handle Dutch variants
        if (dutchVariants.includes(lng)) {
          return 'nl';
        }

        // Default everything else to Dutch
        return 'nl';
      },
    },

    // Supported languages
    supportedLngs: ['en', 'nl'],

    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    react: {
      useSuspense: true,
    },
    resources: {
      en: {
        translation: enTranslation,
      },
      nl: {
        translation: nlTranslation,
      },
    },
  });

export default i18n;

// Utility function to force change language
export const changeLanguage = (language = 'nl') => {
  // Clear existing localStorage entry
  localStorage.removeItem('i18nextLng');

  // Change language
  i18n.changeLanguage(language);

  // Ensure it's saved to localStorage
  localStorage.setItem('i18nextLng', language);
};

// Utility function to force Dutch language (for Netherlands users)
export const forceNetherlandsLanguage = () => {
  changeLanguage('nl');
};

// Utility function to reset to Dutch default (removes any English override)
export const resetToDefaultLanguage = () => {
  // Clear any existing language preference
  localStorage.removeItem('i18nextLng');

  // This will trigger the detection logic which now defaults to 'nl'
  i18n.changeLanguage('nl');
};
